import { render, staticRenderFns } from "./PopupRouterView.vue?vue&type=template&id=1550d349"
import script from "./PopupRouterView.vue?vue&type=script&lang=js"
export * from "./PopupRouterView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports